import React, { useState, useEffect } from 'react';
import moment from 'moment';

import Modal from '../../common/components/Modal/modal';
import numberFormat  from '../../common/constants/NumberFormat';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import { monthsIndexShort as months } from "./monthsIndex";
import buildingblue from '../../images/icons/buildingblue.svg';
import verified from '../../images/icons/verified.svg';
import verification_failed from '../../images/icons/verification_failed.svg';
import Style from './CreditReport.module.css';
import './LoanDetails.css'

const LoanDetails = ({ showModal, setShowModal, modaldata }) => {

  const { modal_det } = Style;
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const years = 
    modaldata?.creditAccountsHistory?.map(item => item["year"])
    .filter((value, index, self) => self.indexOf(value) === index);
  const yearlyData = years?.map(year => {
    let item = { year: null, payments: [] };
    modaldata?.creditAccountsHistory?.forEach(function(entry){
      if(entry.year == year){
        item["year"] = year;
        item["payments"].push(entry);
      }
    })
    return item;
  })
  
  return (
    <Modal
      show={showModal}
      setShow={setShowModal}
      styleContainer={{ maxHeight: '80vh' }}
      classStyle={modal_det}
    >
      <div className="w-full mx-auto mb-2 sm:p-5 p-0 overscroll-contain">
        <p className="sm:mx-4">Loan Details</p>
        <div className="md:flex flex-wrap  sm:mx-4 pt-4">
          <div className={`md:w-4/12 w-full `}>
            <div className="flex items-center py-2 my-1 px-1">
              <div className={`mr-1 items-center`}>
                <img src={buildingblue} />
              </div>
              <div className="w-full items-center">
                <p className="font-roboto lg:text-lg text-sm text-black">
                  {modaldata?.insitution || 'NA'}
                </p>
              </div>
            </div>
          </div>
          <div className={`md:w-8/12 w-full xl:text-right`}>
            <div className="flex  py-2 my-1 px-1">
              <div className="w-full sm:flex xl:ml-64 md:px-4 md:ml-46 ">
                <p className="text-grey-1003  font-roboto font-normal text-sm">
                  Status -
                </p>
                <p className="text-green-flagGreen md:pl-4 pr-8 font-roboto text-sm ">
                  {modaldata?.status || '---'}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={`flex flex-wrap`}>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className="md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                Type of Loan
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.type || 'NA'}
              </p>
            </div>
          </div>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className=" md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Sanction Loan Amount
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.sanctionedAmount
                  ? `₹ ${numberFormat(modaldata?.sanctionedAmount)}`
                  : 0}
              </p>
            </div>
          </div>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className="md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Current balance Amount
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.currentBalance
                  ? `₹ ${numberFormat(modaldata?.currentBalance)}`
                  : 0}
              </p>
            </div>
          </div>
        </div>
        <div className={`flex flex-wrap`}>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className="md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                Account Number
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.accountNumber || 'NA'}
              </p>
            </div>
          </div>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className=" md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Account Holder Type
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.accountHolderType || 'NA'}
              </p>
            </div>
          </div>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className="md:my-10 my-4">
              <p className="text-grey-1003  font-roboto font-normal text-sm">
                Date Reported
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.dateReported
                  ? moment(modaldata?.dateReported).format('Do MMM YYYY')
                  : 'NA'}
              </p>
            </div>
          </div>
        </div>
        <div className={`flex flex-wrap`}>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className="md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm text-left">
                Date Opened
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.dateOpened
                  ? moment(modaldata?.dateOpened).format('Do MMM YYYY')
                  : 'NA'}
              </p>
            </div>
          </div>
          <div className={`block sm:px-6 md:w-4/12 sm:w-6/12 w-full`}>
            <div className=" md:my-10 my-4">
              <p className="text-grey-1003 font-roboto font-normal text-sm">
                Overdue
              </p>
              <p className="text-black-400 font-roboto lg:text-lg text-sm">
                {modaldata?.due ? `₹ ${numberFormat(modaldata?.due)}` : 0}
              </p>
            </div>
          </div>
        </div>

        <div className="my-2">
          <div className="flex items-center text-teal bg-grey-450 p-2 my-2">
            <FontAwesomeIcon icon={faAngleDoubleRight} size="2x" className="mr-2" />
            <h2 className="font-bold">
              Repayment History
            </h2>
          </div>
          <div className="text-center">
            <table className="table-auto m-auto">
              <colgroup>
                <col className="bg-blue-800" />
              </colgroup>
              <thead>
                <tr>
                  <th className="bg-blue-800 p-4 border-2 border-blue-800"></th>
                  { Object.keys(months).map(num => 
                    <th key={`month${num}`}className="font-medium p-4 bg-blue-800 border-2 border-blue-800">{months[num]}</th> 
                  )}
                </tr>
              </thead>
              <tbody className="relative">
                { yearlyData?.map(item => 
                <tr key={item.year}>
                  <td className="p-4 border-2 border-blue-800">
                    {item.year}
                  </td>
                  { Object.keys(months).map(num => {
                    const found = item.payments.find(x => x.month == num);
                    return (
                      <td key={`${item.year}-${num}`} className="p-4 border-2 border-blue-800 tooltip">
                      { found 
                        ? <React.Fragment>
                          { found?.daysDue
                            ? <img src={verification_failed} alt="not cleared" />
                            : <img src={verified} alt="cleared" />
                          }
                            <div class="bg-black-200 p-2 rounded shadow-md tooltiptext">
                            { found?.daysDue
                              ? <span>
                                  <span className="text-blue-800 text-xs">Days Due</span><br/>
                                  <span className="text-blue-800 text-sm">{found?.daysDue}</span>
                                </span>
                              : <span className="text-blue-800 text-sm">Paid</span>
                            }
                              <hr className="my-1" />
                              <span>
                                <span className="text-blue-800 text-xs">Asset classification</span><br/>
                                <span className="text-blue-800 text-sm">{found?.assetClassification}</span>
                              </span>
                            </div>
                          </React.Fragment>
                        : <React.Fragment>
                            <span>-</span>
                            <div class="bg-black-200 p-2 rounded shadow-md tooltiptext">
                              <span class="text-blue-800 text-sm">
                                No data available
                              </span>
                            </div>
                          </React.Fragment>
                      }
                      </td>
                    )
                  })}
                </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </Modal>
  )
}

export default LoanDetails;